import { IonContent } from '@ionic/react';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { LogoWithAppName } from '@/pages/Onboarding/components/LogoWithAppName';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import { useCharacterFolder } from '../../hooks';

import {
  MainImageStyles,
  OverlayStyles,
  PageStyles,
  PageTitleStyles,
  SubtitleStyles,
} from './WelcomeScreen.styles';

export const WelcomeScreen: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'WelcomeScreen',
      });
    }
  }, []);

  const { wizard } = useOnboarding();
  const { getAsset } = useCharacterFolder();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <PageStyles>
      <IonContent scrollY={false}>
        <OverlayStyles />
        <MainImageStyles>
          <img src={getAsset('welcome/splash.jpg')} alt="AI Character" />
        </MainImageStyles>
        <div className="content-wrapper">
          <LogoWithAppName className="app-logo" withCaption={false} />
          <PageTitleStyles
            className="page-title"
            component="h1"
            variant="title-large"
            align="center"
          >
            Ready to meet your perfect
            <UiTypography variant="title-large" color="gradient" align="center">
              AI Boyfriend?
            </UiTypography>
            <SubtitleStyles variant={'body-medium'}>
              Design your ideal partner, choose the setting,
              <br />
              and live a night to remember.
            </SubtitleStyles>
          </PageTitleStyles>
          <OnboardingFooter
            buttonSize={'large'}
            buttonRadius="md"
            onContinue={handleNextStep}
            buttonText={'Let’s go!'}
          />
        </div>
      </IonContent>
    </PageStyles>
  );
};
